import { render, staticRenderFns } from "./DetailsInfoRichiestaAlternanza.vue?vue&type=template&id=3e00ee12&scoped=true&"
import script from "./DetailsInfoRichiestaAlternanza.vue?vue&type=script&lang=ts&"
export * from "./DetailsInfoRichiestaAlternanza.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsInfoRichiestaAlternanza.vue?vue&type=style&index=0&id=3e00ee12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e00ee12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow,VTab,VTabItem,VTabs})
